import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'

interface ICheckBoxProps {
  children?: React.ReactNode
  className?: string
  value: boolean
  onChange: (newValue: boolean) => any
  style?: React.CSSProperties
  tabIndex?: number
}

export default class CheckBox extends React.PureComponent<ICheckBoxProps, {}> {
  public render() {
    const iconName = this.props.value ? 'check-circle' : 'circle'
    return (
      <label
        tabIndex={this.props.tabIndex}
        className={this.props.className}
        role='button'
        onClick={() => this.props.onChange(!this.props.value)}
        style={this.props.style}
      >
        <FontAwesomeIcon icon={['fal', iconName]} /> {this.props.children}
      </label>
    )
  }
}
